export default "__VITE_ASSET__Bt7KbJt5__"